import LayoutComposer from './LayoutComposer.js';
import LayoutSingleColumn from './LayoutSingleColumn/LayoutSingleColumn';
import LayoutSideNavigation from './LayoutSideNavigation/LayoutSideNavigation';
import LayoutSingleColumnMidle from './LayoutSingleColumnMidle/LayoutSingleColumnMidle';


export { LayoutSingleColumn, LayoutSideNavigation, LayoutSingleColumnMidle };
export default LayoutComposer;
